module.exports = __webpack_public_path__ + "static/WEDDING E&M-437-59025735e76e9148e1bd2eae91d511c7.jpg";